import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from '../../../../layout/header/header.component';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PERMISSION_INTERFACES } from 'src/app/misc/data/permissions';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { QuestionControlService } from 'src/app/misc/component/dynamic-form/question-control.service';
import { cloneDeep } from 'lodash';
import { DataService } from 'src/app/services/data.service';
import { SerializeService } from 'src/app/services/serialize.service';
import { TreeNode } from 'primeng/api';
import { PermissionUpdateHandlerService } from 'src/app/services/permission-update-handler.service';
import { Router } from '@angular/router';


import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-create-permission',
  templateUrl: './create-permission.component.html',
  styleUrls: ['./create-permission.component.scss'],
  providers: [QuestionControlService],
})
export class CreatePermissionComponent {

  @ViewChild('scrollTarget') scrollTarget!: ElementRef;
  isScrolled: boolean = false;
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    // Check the scroll position and set isScrolled accordingly
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.isScrolled = scrollPosition > 700;
  }

  header = 'إنشاءالصلاحيات';
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-chevron-circle-right',
      link: '/admin/users/roles/permission',
      visible: this.permissionService.hasPermission('ROLE_MANAGEMENT', 'r'),
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
    { name: this.translate('Organizing roles'), link: '/admin/users/roles' },
    { name: this.translate('Powers'), link: '/admin/users/roles/permission' },
    { name: this.translate('Create permissions'), link: '/admin/users/roles/permission/add' },
  ];
  stats: stat[] = [];
  cols: any = [
    { field: 'unitName', header: 'الواجهة' },
    { field: 'ou', header: 'الوحدة التنظيمية' },
    { field: 'tag', header: 'العلامات' },
    { field: 'read', header: 'قراءة' },
    { field: 'write', header: 'كتابة' },
    { field: 'update', header: 'تحديث' },
    { field: 'delete', header: 'حذف' },
    { field: 'allow', header: 'سماح' },
    { field: 'disallow', header: 'حظر' },
  ];

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'label',
    selectAllText: 'Select All',
    unSelectAllText: 'Select All',
    itemsShowLimit: 1,
  };

  //All Tag Data for all permissions linked with alias
  tags: any = {
    'ou_type_tag': [
      { label: this.translate("Ministries/Entities"), value: "Ministries/Entities" },
      { label: this.translate("Organisational Units"), value: "Organisational Units" },
      { label: this.translate("Organisational Structure"), value: "Organisational Structure" },
      { label: this.translate("Branches"), value: "Branches" },
      { label: this.translate("Content Related"), value: "Content Related" }
    ],
    'survey_type_tag': [],
    'assessment_tag': [],
    'graph_tags': [],
    'training_type': [],
    'data_type': []
  };

  //Tree structured Organizational Units
  treeData: TreeNode[] = [];

  //Predefined permission template to render components
  permissionTemplate: any;

  //Loading screen
  skelition: boolean = true;

  //Static images backend url
  staticURL = GlobalConstants.staticFilesURL;

  //Permission name model
  permissionName: string = '';

  //Model to show error or success messages
  messages: any[] = [];

  //Mark all fields attribute
  selectAll: boolean = false;

  //Parent OUS that don't have IDS
  parentOUS = [
    'الجهات المشاركة',
    'الوزارات',
    'كيانات أخرى',
    'وحدة التنظيم',
  ];

  //Comming for update or new create
  isUpdate: boolean = false;
  //ID of entry to update
  updateId: string = '';
  //Update entry active status
  updateActive: boolean = false;
  translator: TranslatorPipe = new TranslatorPipe()

  constructor(
    private permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
    private dataService: DataService,
    private permissionUpdateService: PermissionUpdateHandlerService,
    private router: Router
  ) { }

  ngOnInit() {


    Promise.all([this.getSurveyTags(), this.getDataTypes(), this.getAssessmentTags(), this.getMysteryShopperTags(), this.getGraphTags(), this.getOUS(), this.getTrainingTypes()]).then((e) => {
      let updateData = this.permissionUpdateService.permissionData;
      if (updateData != null) {
        this.permissionName = updateData.name;
        this.permissionTemplate = updateData.permissions;
        this.isUpdate = true;
        this.updateId = updateData._id;
        this.updateActive = updateData.active;
        console.log('TAGS INFO',this.tags);
        this.setDefaultParentOUS();
      } else {
        this.permissionTemplate = PERMISSION_INTERFACES;
        this.isUpdate = false;
      }
      this.skelition = false;
    });
  }

  async getSurveyTags() {
    try {
      let res = await this.dataService.getData('survey-tags/SURVEY')
      if (res.error) {
        return;
      }
      this.tags['survey_type_tag'] = res.data.map((tag: any) => {
        return {
          _id: tag._id,
          label: tag.arabic,
          value: tag.tag
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  async getDataTypes() {
    try {
      let res = await this.dataService.postData('data-type/get/?offset=1000&page=1', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.tags['data_type'] = res.data.map((tag: any) => {
        return {
          _id: tag._id,
          label: tag.arabic,
          value: tag._id
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  getTrainingTypes = async () => {
    try {
      const res = await this.dataService.postData('training-type/get/?offset=1000&page=1', {});
      if (res.error) {
        console.error('Error fetching data:', res.error);
        return;
      }
      if (res.data) {
        this.tags['training_type'] = res.data.map((item: any) => {
          return {
            _id: item._id,
            label: item.arabic,
            value: item._id
          }
        })
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  async getGraphTags() {
    try {
      let res = await this.dataService.getData('survey-tags/GRAPH')
      if (res.error) {
        return;
      }
      this.tags['graph_tags'] = res.data.map((tag: any) => {
        return {
          _id: tag._id,
          label: tag.arabic,
          value: tag.tag
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  async getAssessmentTags() {
    try {
      let res = await this.dataService.getData('survey-tags/ASSESSMENT')
      if (res.error) {
        return;
      }
      this.tags['assessment_tag'] = res.data.map((tag: any) => {
        return {
          _id: tag._id,
          label: tag.arabic,
          value: tag.tag
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  async getMysteryShopperTags() {
    try {
      let res = await this.dataService.getData('survey-tags/MS')
      if (res.error) {
        return;
      }
      this.tags['mystery_shopper_tag'] = res.data.map((tag: any) => {
        return {
          _id: tag._id,
          label: tag.arabic,
          value: tag.tag
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy() {
    this.resetForm();
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  setDefaultParentOUS() {
    this.permissionTemplate
      .filter((p: any) => p.ouRequired)
      .forEach((parent: any) => {
        parent.ou = this.orgUnits.extractOUChildren(this.treeData, parent.ouLabel);
      });
  }

  //Setting parent OUS to null or setting IDS as values for childs into a cloned array
  checkParentOUS() {
    let data = cloneDeep(this.permissionTemplate);
    data
      .filter((p: any) => p.ouRequired)
      .forEach((parent: any) => {
        if (parent.ou) {
          parent.ouLabel = parent.ou.label;
          if (this.parentOUS.includes(parent.ou.label)) {
            parent.ou = null;
          } else {
            parent.ou = parent.ou._id;
          }
        } else {
          parent.ou = null;
          parent.ouLabel = this.parentOUS[0];
        }
        if (parent.children && parent.children.length > 0) {
          parent.children
            .filter((c: any) => c.ouRequired)
            .forEach((child: any) => {
              if (child.ou) {
                child.ouLabel = child.ou.label;
                if (this.parentOUS.includes(child.ou.label)) {
                  child.ou = null;
                } else {
                  child.ou = child.ou._id;
                }
              } else {
                child.ou = null;
                child.ouLabel = this.parentOUS[0];
              }
            });
        }
      });
    return data;
  }

  //Reset OUS to empty after submitting form
  resetOUS() {
    this.permissionTemplate
      .filter((p: any) => p.ouRequired)
      .forEach((parent: any) => {
        if (parent.ou) {
          parent.ou = null;
        }
        if (parent.children && parent.children.length > 0) {
          parent.children
            .filter((c: any) => c.ouRequired)
            .forEach((child: any) => {
              if (child.ou) {
                child.ou = null;
              }
            });
        }
      });
  }

  resetTags() {
    this.permissionTemplate
      .filter((p: any) => p.tagRequired)
      .forEach((parent: any) => {
        if (parent.tag) {
          parent.tag = null;
        }
        if (parent.children && parent.children.length > 0) {
          parent.children
            .filter((c: any) => c.tagRequired)
            .forEach((child: any) => {
              if (child.tag) {
                child.tag = null;
              }
            });
        }
      });
  }

  //Save Permission to database and reset form
  async submitForm() {
    try {
      if (!this.permissionName || this.permissionName == '') {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: 'Please enter permission name',
          },
        ];
        return;
      }

      let pWithOU = this.checkParentOUS();
      let data: any = {
        name: this.permissionName,
        permissions: pWithOU,
      };

      if (this.isUpdate) {
        data['_id'] = this.updateId;
        data['active'] = this.updateActive;
      }

      this.skelition = true;
      let res = await this.dataService.postData(
        'permission',
        JSON.stringify(data),
        this.isUpdate ? 'PUT' : 'POST',
        false
      );

      console.log('RESPONSe====', res);
      if (res.error) {
        this.skelition = false;
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      if (this.isUpdate) {
        this.router.navigate(['admin/users/roles/permission']);
        return;
      }
      this.resetForm();
      this.skelition = false;
    } catch (e) {
      console.log(e);
    }
  }

  //Check all checkboxes at once
  handleMarkAll(value: any) {
    this.permissionTemplate.forEach((parent: any) => {
      if (parent.ouRequired) {
        if (value) {
          parent.ou = this.treeData[0];
        } else {
          parent.ou = null;
        }
      }
      if (parent.tagRequired) {
        if (value) {
          parent.tag = this.tags[parent.tagAlias].map((t: any) => t.value);
          console.log(parent.tag)
        } else {
          parent.tag = null;
        }
      }
      for (let key in parent.options.options) {
        parent.options.options[key] = value;
      }
      if (parent.children && parent.children.length > 0) {
        parent.children.forEach((child: any) => {
          if (child.ouRequired) {
            if (value) {
              child.ou = this.treeData[0];
            } else {
              child.ou = null;
            }
          }
          if (child.tagRequired) {
            if (value) {
              child.tag = this.tags[child.tagAlias].map((t: any) => t.value);
              console.log(child.tag)
            } else {
              child.tag = null;
            }
          }
          for (let key in child.options.options) {
            child.options.options[key] = value;
          }
        });
      }
    });
    console.log(this.permissionTemplate);
  }

  //Fetch all OUS in tree structure
  private async getOUS() {
    this.treeData = await this.orgUnits.getOrgUnits();
  }

  //Reset the form to initial values
  private resetForm() {
    this.resetOUS();
    this.resetTags();
    this.handleMarkAll(false);
    this.permissionTemplate = PERMISSION_INTERFACES;
    this.selectAll = false;
    this.permissionName = '';
    this.permissionUpdateService.permissionData = null;
  }

  //Check if URL is an image or not
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }
}
